var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgMoney = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M10.718593,12.8735005 L13.2713568,12.8735005 C14.3165829,12.8735005 15.160804,13.697928 15.160804,14.7186478 C15.160804,15.7393675 14.3165829,16.563795 13.2713568,16.563795 L8.67839196,16.563795 C8.1758794,16.563795 7.7638191,16.9661941 7.7638191,17.4569248 C7.7638191,17.9476554 8.1758794,18.3500545 8.67839196,18.3500545 L11.080402,18.3500545 L11.080402,20.1068702 C11.080402,20.5976009 11.4924623,21 11.9949749,21 C12.4974874,21 12.9095477,20.5976009 12.9095477,20.1068702 L12.9095477,18.3500545 L13.281407,18.3500545 C15.3316583,18.3500545 17,16.7208288 17,14.7186478 C17,12.7164667 15.3316583,11.087241 13.281407,11.087241 L10.7286432,11.087241 C9.68341709,11.087241 8.83919598,10.2628135 8.83919598,9.24209378 C8.83919598,8.22137405 9.68341709,7.39694656 10.7286432,7.39694656 L15.241206,7.39694656 C15.7437186,7.39694656 16.1557789,6.99454744 16.1557789,6.50381679 C16.1557789,6.01308615 15.7437186,5.61068702 15.241206,5.61068702 L12.919598,5.61068702 L12.919598,3.89312977 C12.919598,3.40239913 12.5075377,3 12.0050251,3 C11.5025126,3 11.0904523,3.40239913 11.0904523,3.89312977 L11.0904523,5.62050164 L10.718593,5.62050164 C8.66834171,5.62050164 7,7.24972737 7,9.2519084 C7.01005025,11.2442748 8.67839196,12.8735005 10.718593,12.8735005 Z"
  }));
};
export default SvgMoney;